var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Learn50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b9bfcc",
    d: "M41,59a10.657,10.657,0,0,1-6-9V48H25v2a10.657,10.657,0,0,1-6,9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10.02,
    x: 19,
    y: 9.98,
    fill: "#346d92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccd0da",
    d: "M52,44v3.94A2.057,2.057,0,0,1,49.94,50H10.06A2.057,2.057,0,0,1,8,47.94V44l1-1H51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2783ec",
    d: "M52,20.06V44H8V20.06A2.057,2.057,0,0,1,10.06,18H49.94A2.057,2.057,0,0,1,52,20.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#295474",
    d: "M29.921,12.857l15.367-4.88a1.026,1.026,0,0,0,0-1.954L29.921,1.143a3.032,3.032,0,0,0-1.842,0L12.712,6.023a1.026,1.026,0,0,0,0,1.954l15.367,4.88A3.032,3.032,0,0,0,29.921,12.857Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M44,27.091a3,3,0,0,1-6,0C38,25.484,41,22,41,22S44,25.484,44,27.091Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc10a",
    d: "M38.852,44l-.847-11.858A2,2,0,0,1,40,30h2A2,2,0,0,1,44,32.142L43.148,44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a696f0",
    d: "M16.541,30a4,4,0,1,1,7.29-3.15L24,31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc10a",
    d: "M22,36h7.83a1.225,1.225,0,0,0,.97-1.9l-4.83-7.56a1.141,1.141,0,0,0-1.94,0l-2.37,3.71Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 14.001,
    y: 30,
    fill: "#a9dc62",
    rx: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#295474",
    d: "M45,15a1,1,0,0,1-1-1V7a1,1,0,0,1,2,0v7A1,1,0,0,1,45,15Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8991a0",
    d: "M44,59H16a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Learn50);
export default __webpack_public_path__ + "static/media/icons8-learn-50.0c3c307197da5ed7d3830a501c1ddc1e.svg";
export { ForwardRef as ReactComponent };